
import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import { inject, observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { Form, Button, Icon, Checkbox, message } from 'antd'
import { FormattedMessage, injectIntl } from 'react-intl'
// import { Button, Form, Icon, Steps, Radio } from 'antd'
import queryString from 'query-string'
import _sortBy from 'lodash/sortBy'
// import moment from 'moment'
import _get from 'lodash/get'
import _uniq from 'lodash/uniq'
import _flatten from 'lodash/flatten'
import _intersection from 'lodash/intersection'
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  arrayMove
} from 'react-sortable-hoc'

// import ParticipantItem from '~/App/components/ParticipantItem'
import renderQuestionInput from '~/renderQuestionInput'
import RegistrationSteps from '~/App/components/RegistrationSteps'
import ParticipantItem from '~/App/components/ParticipantItem'
import ParticipantEditModal from '~/App/components/ParticipantEditModal'
import registrationQuery from '~/App/graphql/queries/registration.gql'
import updateParticipantMutation from '~/App/graphql/mutations/updateParticipant.gql'
import setRegistrationProductItemsMutation from '~/App/graphql/mutations/setRegistrationProductItems.gql'

const SortableHandleIcon = SortableHandle((...props) => (
  <Icon type="swap" style={{ transform: 'rotate(90deg)', fontSize: '18px', color: 'grey' }} />
))
const SortableParticipantItem = SortableElement(ParticipantItem)
const SortableParticipantList = SortableContainer(({ participants, onOrderChange }) => (
  <div>
    {_sortBy(participants, ['order']).map((participant, index) => (
      <SortableParticipantItem key={participant._id} participant={participant} index={index} isFirst={index === 0} isLast={index === participants.length - 1 } onOrderChange={onOrderChange} sortHandle={<SortableHandleIcon />}/>
    ))}
  </div>
))
// import saveRegistrationMutation from '~/App/graphql/mutations/saveRegistration'
@Form.create()
@injectIntl
@graphql(registrationQuery, {
  options: ({ match: { params: { id } } }) => ({
    variables: { _id: id },
    fetchPolicy: 'network-only'
  })
})
@graphql(updateParticipantMutation, {
  name: 'updateParticipant'
})
@graphql(setRegistrationProductItemsMutation, {
  name: 'setRegistrationProductItems'
})
@inject('i18n')
@observer
class RegistrationEdit extends Component {
  state = {
    submitting: false,
    participants: [],
    productTypeIds: null
  }
  componentWillReceiveProps (nextProps) {
    const { data, match: { params: { id } } } = nextProps
    const status = _get(data, 'registration.status')
    const participants = _get(data, 'registration.participants', [])
    const eventProducts = _get(data, 'registration.eventProducts', [])
    const productTypeIds = eventProducts.map(p => _get(p, 'productTypeId'))
    this.setState({
      participants: _sortBy(participants, ['order'])
    })

    this.setState(state => ({
      ...state,
      productTypeIds: state.productTypeIds || productTypeIds
    }))

    // const event = _get(registration, 'event')
    // const expired = _get(registration, 'expired')
    // const periods = _get(event, 'periods', [])
    // // const preRegisterPeriod = _get(event, 'preRegisterPeriod')
    // const currentPeriod = periods.find(period =>
    //   moment().isBetween(period.start, period.end)
    // )
    // const preRegisterOpen = currentPeriod && currentPeriod.preRegister
    if (['paid', 'payment_verifying'].includes(status)) {
      this.props.history.replace(`/reg/${id}`)
    }
  }
  handleSaveRegistration = e => {
    e.preventDefault()
    const { i18n: { locale }, data, intl, history, match: { params: { id } } } = this.props
    const { participants } = this.state
    const registrationType = _get(data, 'registration.registrationType')
    const requiredTicketTypeIds = _get(registrationType, 'requiredTicketTypeIds', [])
    const participantUniqueEmail = _get(data, 'registration.event.settings.participant.uniqueEmail')
    const minParticipants = _get(registrationType, 'minParticipants', 1) || 1
    const maxParticipants = _get(registrationType, 'maxParticipants')
    const restrictions = _get(registrationType, 'restrictions', [])

    const ticketTypes = _get(data, 'registration.event.ticketTypes', [])
    const requiredTicketTypes = ticketTypes.filter(tt => requiredTicketTypeIds.includes(tt._id))

    // const {
    //   history,
    //   match: { params: { id } }
    // } = this.props
    // console.log(participants.length, minParticipants)
    // return
    if (participants.length < minParticipants) {
      const $message = intl.formatMessage({
        id: 'app.minParticipantsNotice',
        defaultMessage: 'Please add more participant'
      }, {
        min: minParticipants
      })
      history.push(`/reg/${id}/edit?pId=new`)
      return message.warning($message)
    } else if (maxParticipants && participants.length > maxParticipants) {
      const $message = intl.formatMessage({
        id: 'app.maxParticipantsNotice',
        defaultMessage: 'Only {max} participants allowed'
      }, {
        max: maxParticipants
      })
      history.push(`/reg/${id}/edit?pId=new`)
      return message.warning($message)
    } else {
      const genders = participants.map(p => _get(p, 'profile.gender'))
      if (restrictions.includes('gender_mix') &&
        (!genders.includes('male') || !genders.includes('female'))
      ) {
        const $message = intl.formatMessage({
          id: 'app.genderMixError',
          defaultMessage: 'Group should contain both male and female participants'
        })
        return message.warning($message)
      } else if (restrictions.includes('gender_male') && genders.includes('female')) {
        const $message = intl.formatMessage({
          id: 'app.genderMaleOnlyError',
          defaultMessage: 'Only male participants allowed'
        })
        return message.warning($message)
      } else if (restrictions.includes('gender_female') && genders.includes('male')) {
        const $message = intl.formatMessage({
          id: 'app.genderFemaleOnlyError',
          defaultMessage: 'Only female participants allowed'
        })
        return message.warning($message)
      }

      if (participantUniqueEmail &&
        _uniq(participants.map(p => _get(p, 'profile.email'))).length !== participants.length
      ) {
        const $message = intl.formatMessage({
          id: 'app.participantEmailUnique',
          defaultMessage: 'Each participant should have unique email'
        })
        return message.warning($message)
      }

      if (requiredTicketTypeIds.length > 0) {
        const ticketTypeIds = _flatten(participants.map(p => _get(p, 'tickets'))).map(t => _get(t, 'ticketType._id'))
        const intersection = _intersection(requiredTicketTypeIds, ticketTypeIds)
        if (registrationType.requiredTicketTypeMode === 'any') {
          if (intersection.length === 0) {
            // const $message = intl.formatMessage({
            //   id: 'app.participantEmailUnique',
            //   defaultMessage: 'Each participant should have unique email'
            // })
            return message.warning(intl.formatMessage({
              id: 'app.requireAnyTickets',
              defaultMessage: 'Registration should include any of the following {ticketTypes}'
            }, {
              ticketTypes: requiredTicketTypes.map(tt => _get(tt, ['name', locale])).join(', ')
            }))
          }
        } else if (registrationType.requiredTicketTypeMode === 'all') {
          if (intersection.length !== requiredTicketTypeIds.length) {
            return message.warning(intl.formatMessage({
              id: 'app.requireAllTickets',
              defaultMessage: 'Registration should include all of the following {ticketTypes}'
            }, {
              ticketTypes: requiredTicketTypes.map(tt => _get(tt, ['name', locale])).join(', ')
            }))
          }
        }
      }
      // console.log({ restrictions, genders })

      this.props.form.validateFields((err, data) => {
        if (!err) {
          const { eventProducts = [] } = data
          const productItems = Object.values(eventProducts).filter(item =>
            this.state.productTypeIds.includes(item.productTypeId)
          )
          // console.log({ productItems })
          this.props.setRegistrationProductItems({
            variables: {
              _id: id,
              productItems
            }
          })
        }
        this.setState({
          submitting: true
        })
        history.push(`/reg/${id}/preview`)
      })
    }
    // console.log()
  }

  handleOrderChange = ({ from, to }) => this.handleSortEnd({ oldIndex: from, newIndex: to })

  // TODO: should set sorted participant in state and use value from state
  handleSortEnd = ({ oldIndex, newIndex }) => {
    const { updateParticipant } = this.props
    const { participants } = this.state
    // const participants = _sortBy(_get(data, 'registration.participants', []), ['order'])
    const sortedParticipants = arrayMove(participants, oldIndex, newIndex)

    const updateParticipants$ = sortedParticipants.map((participant, index) => {
      if (participant.order !== index) {
        return updateParticipant({
          variables: {
            record: {
              _id: participant._id,
              order: index
            }
          },
          optimisticResponse: {
            __typename: 'Mutation',
            updateParticipant: {
              __typename: 'ParticipantInput',
              record: {
                __typename: 'Participant',
                ...participant,
                order: index
              }
            }
          }
        })
      } else {
        return Promise.resolve()
      }
    })
    return Promise.all(updateParticipants$)
  }
  handleProductItemsChange = (productTypeIds) => {
    this.setState({
      productTypeIds
    })
  }
  handleSelectProductItem = (e) => {
    // e.preventDefault()
    const { productTypeIds: pItemIds } = this.state
    let productTypeIds
    if (e.target.checked) {
      productTypeIds = pItemIds.concat(e.target.value)
    } else {
      productTypeIds = pItemIds.filter(item => item !== e.target.value)
    }
    this.setState({ productTypeIds })
  }
  render () {
    const {
      data,
      location: { search },
      match: { params: { id } },
      i18n: { locale },
      form: { getFieldDecorator }
    } = this.props
    const registration = _get(data, 'registration')
    if (!registration) {
      return <div>Loading...</div>
    }
    const event = _get(data, 'registration.event')
    const eventProductTypes = _get(event, 'productTypes')
    const { participants } = this.state
    // const participants = _get(data, 'registration.participants', [])
    const registrationType = _get(data, 'registration.registrationType')
    const eventProducts = _get(data, 'registration.eventProducts', [])
    const productTypeIds = _get(registrationType, 'productTypeIds', [])
    // const productTypes = []
    const productTypes = eventProductTypes.filter(pt => productTypeIds.includes(pt._id))
    // const productTypeOptions = productTypes.map(productType => ({
    //   label: _get(productType, ['name', locale]),
    //   value: productType._id
    // }))

    // console.log({ eventProductTypes, productTypeIds, productTypes })
    // console.log({ registrationType })
    // console.log(this.state.productTypeIds)
    const { pId } = queryString.parse(search)
    const editingParticipant = !!pId
    return <div>
      <Form onSubmit={this.handleSaveRegistration} style={{ padding: '26px' }} className="EventRegisterPage">
        <div className="eventDetails" style={{ paddingTop: '85px', display: 'flex', justifyContent: ' center' }}>
          <div className="eventTitle">
            {_get(data, ['registration', 'event', 'name', locale])}
          </div>
        </div>
        <div style={{ maxWidth: '1000px', margin: 'auto' }}>
          <RegistrationSteps step="edit" />
          <div style={{ padding: '26px', background: 'white', borderRadius: '0 0 8px 8px' }}>
            <div className="simpleBgColor" style={{
              fontSize: 'large',
              textAlign: 'center',
              marginBottom: '1em'
            }}>
              {registrationType.name[locale]}
            </div>
            <div style={{ textAlign: 'center' }}>
              {(!registrationType.maxParticipants || participants.length < registrationType.maxParticipants) && <Link to={`/reg/${id}/edit?pId=new`}>
                <Button>
                  <Icon type="user-add" />
                  <FormattedMessage id="app.addParticipant" defaultMessage="Add Participant" />
                </Button>
              </Link>}
            </div>
            <SortableParticipantList
              participants={participants}
              onSortEnd={this.handleSortEnd}
              onOrderChange={this.handleOrderChange}
              helperClass="sortable-sorting"
              useDragHandle
              lockAxis="y"
            />
            <div>
              {productTypes.map(productType => {
                const selected = this.state.productTypeIds && this.state.productTypeIds.includes(productType._id)
                const questions = _get(productType, 'questions', [])
                const eventProduct = eventProducts.find(p => (_get(p, 'productTypeId') === productType._id))

                getFieldDecorator(`eventProducts.${productType._id}._id`, {
                  initialValue: eventProduct && eventProduct._id
                })
                getFieldDecorator(`eventProducts.${productType._id}.productTypeId`, {
                  initialValue: productType._id
                })
                return <div key={productType._id}>
                  <div>
                    <Checkbox
                      onChange={this.handleSelectProductItem}
                      value={productType._id}
                      checked={selected}
                      // defaultChecked
                      // default value set in componentWillReceiveProps
                      // TODO: refactor and use internal states
                    >
                      {_get(productType, ['name', locale])}  (<FormattedMessage id="app.amountBaht" values={{ amount: productType.price }} />)
                    </Checkbox>
                  </div>
                  {selected && questions.map((question, questionIndex) => {
                    const option = _get(eventProduct, 'options', []).find(opt => opt.questionId === question._id)

                    getFieldDecorator(`eventProducts.${productType._id}.options`, {
                      initialValue: []
                    })

                    getFieldDecorator(`eventProducts.${productType._id}.options[${questionIndex}]`, {
                      initialValue: {}
                    })
                    getFieldDecorator(`eventProducts.${productType._id}.options[${questionIndex}]._id`, {
                      initialValue: option && option._id
                    })

                    // if (editMode) {
                    //   getFieldDecorator(
                    //     `eventProducts.${productType._id}.options[${questionIndex}]._id`,
                    //     {
                    //       initialValue: _get(ticket, `options[${questionIndex}]._id`)
                    //     }
                    //   )
                    // }
                    getFieldDecorator(
                      `eventProducts.${productType._id}.options[${questionIndex}].questionId`,
                      {
                        initialValue: question._id
                      }
                    )

                    const optionField = {
                      Open: 'value',
                      Choice: 'itemId',
                      MultiChoice: 'itemIds'
                    }[question.kind]
                    const optionValidator = (rule, value, callback) => {
                      // TODO: separate to utils
                      if (question.opts && question.opts.validator) {
                        const { validator } = question.opts
                        let valid = true
                        if (value) {
                          if (validator.itemCount) {
                            if (
                              validator.itemCount.min &&
                              value.length < validator.itemCount.min
                            ) {
                              valid = false
                            }
                            if (
                              validator.itemCount.max &&
                              value.length > validator.itemCount.max
                            ) {
                              valid = false
                            }
                          }
                        } else {
                          valid = false
                        }
                        if (!valid) {
                          const message = `must be between ${validator.itemCount.min} and ${validator.itemCount.max} items`
                          callback(message)
                        }
                      }
                      callback()
                    }
                    const questionRules = [{ validator: optionValidator }]
                    questionRules.push({ required: true, message: `${question.name[locale]} is Required` })
                    const optionDecorator = getFieldDecorator(
                      `eventProducts.${productType._id}.options[${questionIndex}].${optionField}`,
                      {
                        initialValue: _get(option, optionField) || question.default,
                        rules: questionRules
                      }
                    )
                    return (
                      <Form.Item
                        label={question.name[locale]}
                        // {...inputCols}
                        key={questionIndex}
                      >
                        {optionDecorator(renderQuestionInput({ question, locale }))}
                      </Form.Item>
                    )
                  })}
                </div>
              })}
            </div>
            <div style={{ padding: '8px', textAlign: 'right' }}>
              <Button type="primary" htmlType="submit" loading={this.state.submitting}>
                <FormattedMessage id="app.next" defaultMessage="next" />
              </Button>
            </div>
          </div>
        </div>
      </Form>
      {event && registration && pId && <ParticipantEditModal visible={editingParticipant} event={event} registration={registration} participantId={pId} />}
    </div>
  }
}

export default RegistrationEdit



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/RegistrationEdit/RegistrationEdit.js